module.exports = __webpack_public_path__ + "91cf2e1021ecdc7a7df9409448f44b35.svg";